import z from 'zod';
import { ConsumerCreditContext } from '../contexts';
import { createRoute } from '../functions/createRoute';
export const ConsumerCreditOverviewRoute = createRoute('cc-overview', {
    path: '/',
    schema: z.object({}),
    exact: true,
    context: ConsumerCreditContext,
});
export const ConsumerCreditFinancingRoute = createRoute('cc-financing', {
    path: '/financing',
    schema: z.object({}),
    exact: false,
    context: ConsumerCreditContext,
});
export const ConsumerCreditOfferRoute = createRoute('cc-offer', {
    path: '/offer',
    schema: z.object({}),
    exact: false,
    context: ConsumerCreditContext,
});
export const ConsumerCreditLogbookRoute = createRoute('cc-logbook', {
    path: '/logbook',
    schema: z.object({}),
    exact: false,
    context: ConsumerCreditContext,
});
export const ConsumerCreditCommunicationRoute = createRoute('cc-communication', {
    path: '/communication',
    schema: z.object({}),
    exact: false,
    context: ConsumerCreditContext,
});
